import { saveServiceOfferings } from "../../../api";

export const getTagsOnLoad = (serviceOffering, countries) => {
  const newTag = [];
  const tags = `${serviceOffering}-${countries}`;
  if (!newTag.includes(tags)) {
    newTag.push(tags);
  }
  return newTag;
};

export const getTags = (serviceOffering, countries) => {
  if (serviceOffering.label || serviceOffering.length > 0) {
    const newTag = [];
    const tags = `${serviceOffering.label}-${countries
      .map((option2) => option2.label)
      .join(", ")}`;
    if (!newTag.includes(tags)) {
      newTag.push(tags);
    }
    return newTag;
  }
};

export const addNewServiceOfferings = async (serviceOfferings) => {
  if (serviceOfferings?.__isNew__) {
    const newServiceOfferings = {
      operation: "createServiceOffering",
      request: { name: serviceOfferings.value, username: "" },
    };
    const resp = await saveServiceOfferings(newServiceOfferings);
    if (resp?.responseCode === 200) {
      return newServiceOfferings.request;
    }
    return "";
  }
};
